import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { fetchArrowModelAction } from '@root/app/react/action';
import {
    KintekiArrowModel,
    EntekiArrowModel,
    MakiwaraArrowModel,
} from '@app/react/3d/ArrowModelInterface';

// eslint-disable-next-line import/no-mutable-exports
export let kintekiModel: KintekiArrowModel | null = null;
// eslint-disable-next-line import/no-mutable-exports
export let entekiModel: EntekiArrowModel | null = null;
// eslint-disable-next-line import/no-mutable-exports
export let makiwaraModel: MakiwaraArrowModel | null = null;

export interface OrdermadeArrowReducer {
    kinteki: boolean;
    enteki: boolean;
    makiwara: boolean;
}

const initState: OrdermadeArrowReducer = {
    kinteki: false,
    enteki: false,
    makiwara: false,
};

export const ordermadeArrowModelReducer = reducerWithInitialState(initState)
    .case(fetchArrowModelAction, (state, action) => {
        const {
            kinteki,
            enteki,
            makiwara,
        } = action;

        if (kinteki !== undefined) {
            kintekiModel = kinteki;
        }
        if (enteki !== undefined) {
            entekiModel = enteki;
        }
        if (makiwara !== undefined) {
            makiwaraModel = makiwara;
        }

        return {
            ...state,
            kinteki: kintekiModel !== undefined,
            enteki: entekiModel !== undefined,
            makiwara: makiwaraModel !== undefined,
        };
    });
